var map = {
	"./Alpina_Gstaad.jpg": 111,
	"./Backstage_Zermatt.jpg": 112,
	"./Badrutt_St_Moritz.jpg": 113,
	"./Belvedere_Scuol.jpg": 114,
	"./Bergwelt_Grindelwald.jpg": 115,
	"./Chedi_Andermatt.jpg": 116,
	"./Chesa_Randolina_Sils.jpg": 117,
	"./Doldenhorn_Kandersteg.jpg": 118,
	"./Grand_Bellevue_Gstaad.jpg": 119,
	"./Guardaval_Lenzerheide.jpg": 120,
	"./Hornberg_Gstaad.jpg": 121,
	"./Inlain_Brail.jpg": 122,
	"./Kempinski_Engelberg.jpg": 123,
	"./Kernen_Schoenried_Gstaad.jpg": 124,
	"./Krone_La_Punt.jpg": 125,
	"./Kulm_St_Moritz.jpg": 126,
	"./Margna_Sils.jpg": 127,
	"./Meisser_Guarda.jpg": 128,
	"./Palace_Gstaad.jpg": 129,
	"./Priva_Lenzerheide.jpg": 130,
	"./Radisson_Andermatt.jpg": 131,
	"./Riffelalp_Zermatt.jpg": 132,
	"./Rockresort_Laax.jpg": 133,
	"./Schoenegg_Wengen.jpg": 134,
	"./Schweizerhof_Lenzerheide.jpg": 135,
	"./Schweizerhof_Zermatt.jpg": 136,
	"./Spitzhorn_Saanen.jpg": 137,
	"./Sporthotel_Pontresina.jpg": 138,
	"./Steinbock_Pontresina.jpg": 139,
	"./Suvretta_St_Moritz.jpg": 140,
	"./Tschuggen_Arosa.jpg": 141,
	"./Waldhaus_st_Moritz.jpg": 142,
	"./Walther_Pontresina.jpg": 143,
	"./Zermatterhof_Zermatt.jpg": 144,
	"./Zurbriggen_Saas.jpg": 145,
	"./jungfrau-wengernalp.jpg": 146
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(function(id) {
		return __webpack_require__.t(id, 7);;
	});
}
function webpackAsyncContextResolve(req) {
	return __webpack_require__.e(/* lazy-once context | placeholder */ 37).then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 71;
module.exports = webpackAsyncContext;